/* Born of Shadows: discount code field in the cart drawer.
   The drawer is re-rendered by cart-ajax.js (buildCart), so everything here uses event delegation. */
(function () {
  if (window.__bosCartDiscount) return;
  window.__bosCartDiscount = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function msg(box, text, ok) {
    var m = box.querySelector('[data-bos-cdisc-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('is-ok', !!ok);
    m.hidden = !text;
  }

  function refresh(cart) {
    if (typeof window.buildCart === 'function') { window.buildCart(cart, true); }
    else { window.location.reload(); }
  }

  function applyCodes(codes) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }

  function currentCodes() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      });
  }

  // toggle open/closed
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bos-cdisc-toggle]');
    if (!t) return;
    e.preventDefault();
    var box = t.closest('[data-bos-cdisc]');
    var open = !box.classList.contains('is-open');
    box.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var i = box.querySelector('input'); if (i) setTimeout(function () { i.focus(); }, 50); }
  });

  // apply
  function submit(box) {
    var input = box.querySelector('input');
    var btn = box.querySelector('[data-bos-cdisc-apply]');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) { msg(box, 'Enter a code first.'); return; }
    btn.disabled = true; btn.textContent = '...';
    currentCodes()
      .then(function (codes) {
        if (codes.indexOf(code) === -1) codes.push(code);
        return applyCodes(codes);
      })
      .then(function (cart) {
        var found = (cart.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code; })[0];
        if (found && found.applicable) {
          msg(box, code + ' applied.', true);
          setTimeout(function () { refresh(cart); }, 500);
        } else {
          // remove the code that didn't apply so it doesn't linger
          var keep = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
          applyCodes(keep);
          msg(box, "That code can't be used on this cart.");
          btn.disabled = false; btn.textContent = 'Apply';
        }
      })
      .catch(function () {
        msg(box, 'Something went wrong. Try again, or add it at checkout.');
        btn.disabled = false; btn.textContent = 'Apply';
      });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bos-cdisc-apply]');
    if (!b) return;
    e.preventDefault();
    submit(b.closest('[data-bos-cdisc]'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var i = e.target.closest('[data-bos-cdisc] input');
    if (!i) return;
    e.preventDefault();
    submit(i.closest('[data-bos-cdisc]'));
  });

  // remove an applied code
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-bos-cdisc-remove]');
    if (!r) return;
    e.preventDefault();
    var code = r.getAttribute('data-bos-cdisc-remove').toUpperCase();
    currentCodes()
      .then(function (codes) { return applyCodes(codes.filter(function (c) { return c.toUpperCase() !== code; })); })
      .then(refresh);
  });
})();
